package de.ohhhmhhh.backend.models.model.asset

import kotlinx.serialization.Serializable

@Serializable
data class UploadLinkRequest(
    val path: String,
    val contentType: String
)